export default __webpack_public_path__ + "static/media/emptyImage.18a6aef9.png";